import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {map, switchMap, takeUntil} from "rxjs/operators";
import {CheckService} from "../../../../@shared/services/check.service";
import {MatTableDataSource} from "@angular/material/table";
import {MatPaginator} from "@angular/material/paginator";

import {ICheckIp, IUserAuthList, IUserList} from "./check-ip.interface";
import {Subject} from "rxjs";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'app-check-ip',
  templateUrl: './check-ip.component.html',
  styleUrls: ['./check-ip.component.scss']
})
export class CheckIpComponent implements OnInit, OnDestroy {
  @ViewChild('paginator', {static: false}) paginator!: MatPaginator;
  @ViewChild('paginatorByAuth', {static: false}) paginatorByAuth!: MatPaginator;

  public isGoFast: boolean = environment.projectName === 'CSGOFAST';

  usersListColumns: string [] = ['count', 'user', 'balance', 'date', 'locked'];
  byAccountDataSource: MatTableDataSource<IUserList> = new MatTableDataSource<IUserList>();
  usersListByAuthColumns: string [] = ['count', 'user', 'balance', 'login_at', 'date', 'locked'];
  byAuthDataSource: MatTableDataSource<IUserAuthList> = new MatTableDataSource<IUserAuthList>();

  public ip: string;
  public isLoading: boolean = true;
  private readonly destroyed$: Subject<void> = new Subject<void>();

  constructor(private activatedRoute: ActivatedRoute,
              private checkService: CheckService) {
  }

  ngOnInit() {
    this.activatedRoute.paramMap.pipe(
      takeUntil(this.destroyed$),
      map((params: any) => params.get('ip')),
      switchMap((ip: string) => {
        this.ip = ip
        return this.checkService.findByIp(ip);
      }),
    ).subscribe((data: ICheckIp) => {
      this.byAccountDataSource.data = data.byAccount;
      this.byAccountDataSource.paginator = this.paginator;
      this.byAuthDataSource.data = data.byAuth;
      this.byAuthDataSource.paginator = this.paginatorByAuth;
      this.isLoading = false;
    }, () => this.isLoading = false);
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
